export default __webpack_public_path__ + "static/media/alert.29809523.svg";